// some secure options to force only https and samesite access to this cookie
export const defaultSetCookieOptions = '; SameSite=Strict; Secure; Path=/;'

/**
 * Sets a browser accessible cookie via JS, defaulting to expiring after the
 * browser session ends. Keep the small size limit when storing values in cookies.
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Cookies#removal_defining_the_lifetime_of_a_cookie
 * @param {string} name The name/key of the cookie
 * @param {string} value The value to store in the cookie
 * @param {string} options Optional cookie settings like path, domain, etc. Should start with ;
 * @returns {string} The cookie string that was set
 * @example
 * // set a cookie with default settings
 * setCookie('myCookie', 'myValue')
 * @example
 * // set a cookie with custom settings
 * setCookie('myCookie', 'myValue', '; path=/; domain=.mydomain.com Max-Age=1000;')
 */
const setCookie = (
  name: string,
  value: string,
  options: string = defaultSetCookieOptions
): string => {
  // encode just in case of reserved characters being used
  const safeName = encodeURIComponent(name)
  const safeValue = encodeURIComponent(value)
  const cookieString = `${safeName}=${safeValue}${options}`
  // this is actually a setter function to update the existing cookies
  document.cookie = cookieString

  return cookieString
}

export default setCookie
